var $$ = $$ || {};

$$.ProfilePage = class ProfilePage {
	constructor (root, options = {}) {
		var defaultOptions = {};
		this.root = root;
		this.options = _.assign(defaultOptions, options);

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			addNumber:    this.root.find('.js-add-number'),
			input:        this.root.find('input'),
			phone:        this.root.find('input.phone'),
			saveButton:   this.root.find('.js-save'),
			cancelButton: this.root.find('.js-cancel'),
			editButton:   this.root.find('.js-edit'),
			addJurAddress:this.root.find('.js-add-jur-address'),
			jurAddressForm:this.root.find('.js-jur-address-form')
		};
	}

	_bindEvents () {
		this.nodes.editButton.on('click', (event) => {
			event.preventDefault();
			var item = $(event.currentTarget);
			item.parents('.form-part').addClass('edit');

			if ( this.root.find('input.phone').length < 2 ) {
				this.nodes.addNumber.show();
			}
		});

		var phoneTemplate = `
			<div class="row">
                <div class="col-xs-12">
                    <div class="value"></div>
                    <input type="text" class="phone" name="PERSONAL_PHONE" value="" name="phone"/>
                </div>
            </div>
		`;

		this.nodes.addNumber.on('click', (event) => {
			"use strict";
			event.preventDefault();
			var item = $(event.currentTarget);


			if (item.parent().find('input').length >= 2) {
				return;
			}

			var newPhoneField = $(phoneTemplate).appendTo(item.parent());

			this._initMask(newPhoneField.find('input'));
			newPhoneField.find('input').on("focusout", (event) => this._clearBrokenPhoneNumber(event));

			this._updatePhoneFields(item);

			$(event.currentTarget).hide();
		});

		this.nodes.saveButton.on('click', (event) => {
			"use strict";
			var item = $(event.currentTarget);
			var form = item.parents('form');

			item.parents('.form-part').find(`input`).removeClass('error');

			let phoneOne = item.parents('.form-part').find('input.phone').eq(0);
			let phoneTwo = item.parents('.form-part').find('input.phone').eq(1);

			if ( phoneOne.val() === '' && phoneTwo.val() > '' ) {
				phoneOne.val( phoneTwo.val() );
				phoneOne.closest('div').children('.value').text( phoneTwo.val() );

				phoneTwo.val('');
				phoneTwo.closest('div').children('.value').text('');
			}

			$.ajax({
				url:     form.attr('action'),
				method:  form.attr('method'),
				data:    form.serialize(),
				beforeSend: () => {
					if ( phoneTwo.val() === '' ) {
						phoneTwo.closest('.row').remove();
						phoneOne.closest('.row').removeClass('tr');
					}
				},
				success: (response) => {
					response = $.parseJSON(response);

					if (response.success) {
						$$.Noty[ 'successMessage' ](response.success);

						item.parents('.form-part').find('input').each((index, element) => {
							var input = $(element);
							var value = $$.trim(input.val());
							var label = input.siblings('.value');

							if ( value !== '' ) {
								label.text(value);
							} else {
								label.text('');
							}
						});


						var select = item.parents('.form-part').find('select option:selected');
						select.parents('.field').find('.value').text(select.text());

						item.parents('.form-part').removeClass('edit');
						this.nodes.addNumber.hide();
					} else {
						_.each(response.errors, function (value, key) {
							item.parents('.form-part').find(`input[name="${key}"]`).addClass('error');
							$$.Noty[ 'errorMessage' ](value, 4000);
						});
					}
				}
			});
		});

		this.nodes.cancelButton.on('click', (event) => {
			event.preventDefault();
			var item = $(event.currentTarget);

			if (item.parent().hasClass('disabled')) {
				return;
			}

			item.parents('.form-part').find('.field input').each((index, element) => {
				"use strict";

				$(element).val( $$.trim( $(element).closest('div').children('.value').text() ) );

				if ( $(element).hasClass('.phone') ) {
					if ($$.trim($(element).siblings().text()) === '') {
						$(element).parent().parent().remove();
					}
				}
			});

			this._updatePhoneFields(this.nodes.addNumber);

			item.parents('.form-part').removeClass('edit');
			this.nodes.addNumber.hide();
		});

		this.root.on('change', 'input', (event) => {
			var input = $(event.target);
			var label = input.closest('.value');

			label.text(input.val());
		});

		this.root.find('.password-subscribe input').one('change', (event) => {
			"use strict";
			var item = $(event.currentTarget);
			item.parents('form').find('.save-wrap').removeClass('disabled');
			item.parents('form').find('input[type="submit"]').removeAttr('disabled');
		});

		this.root.find('form').on('submit', (event) => {
			"use strict";
			event.preventDefault();
			var form = $(event.currentTarget);
			form.find('.save-wrap').addClass('disabled');
			form.find('input[type="submit"]').attr('disabled', 'disabled');
			form.find('input').removeClass('error');

			$.ajax({
				url:     form.attr('action'),
				method:  form.attr('method'),
				data:    form.serialize(),
				success: (response) => {
					response = $.parseJSON(response);

					if (response.success) {
						$$.Noty[ 'successMessage' ](response.success);

						$(form).find('input.checkbox').each((index, element) => {
							if ( $(element).context.checked ) {
								$(element).attr('checked', true);
							} else {
								$(element).attr('checked', false);
							}
						});
					} else {
						_.each(response.errors, function (value, key) {
							key = key.replace(/\-/g, "_");
							form.find(`input[name="${key}"]`).addClass('error');
							$$.Noty[ 'errorMessage' ](value, 4000);
						});
					}
				},
				complete: () => {
					form.find('.save-wrap').removeClass('disabled');
					form.find('input[type="submit"]').removeAttr('disabled');
				}
			});

		});

		this.nodes.phone.on("focusout", (event) => this._clearBrokenPhoneNumber(event));

		this.nodes.addJurAddress.one('click', (event) => {
			event.preventDefault();

			this.nodes.jurAddressForm.show();

			$(event.currentTarget).hide();
		});
	}

	_updatePhoneFields (item) {
		"use strict";

		item.parent().find('.row').each((index, element) => {
			if (index === item.parent().find('.row').length - 1) {
				$(element).removeClass('tr')
			} else {
				$(element).addClass('tr');
			}
		});
	}

	/**
	 *
	 * @param selector jQuery объект
	 * @private
	 */

	_initMask (selector) {
		"use strict";

		var im = new Inputmask("8 (999) 999-99-99");
		im.mask(selector.get(0));
	}

	_clearBrokenPhoneNumber (event) {
		if ( $(event.currentTarget).val().indexOf("_") > 0 ) {
			$(event.currentTarget).val( $(event.currentTarget).closest('div').children('.value').text() );
		}
	}

	_ready () {
		"use strict";

		this.root.find('input.phone').each((index, element) => {
			this._initMask($(element));
		});

		if ( this.root.find('input.phone').length > 1 ) {
			this.nodes.addNumber.hide();
		} else {
			$$.trim( this.root.find('input.phone').parent().children('.value').text() );
		}

		this.nodes.jurAddressForm.find('input').each((index, element) => {
			if ( $(element).val() > '' ) {
				this.nodes.jurAddressForm.show();
				this.nodes.addJurAddress.hide();

				return;
			}
		});
	}
};
